import { inject, Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { BazisEntityService } from '@bazis/shared/services/entity.service';
import { map } from 'rxjs/operators';

/**
 * StatusPipe loads a status entity by id and returns its `$snapshot`.
 *
 * It calls `BazisEntityService.getEntity$('statusy.status', id)` and maps
 * the result to `$snapshot`. Use with `async` pipe. If `id` is falsy,
 * it returns `of(null)`.
 *
 * Template usage (Angular v20+ syntax):
 *
 * ```html
 *     @let status = (statusId | status | async);
 *     @if (status) {
 *        <span>{{ status?.name }}</span>
 *     }
 * ```
 */
@Pipe({
    name: 'status',
    standalone: true,
})
export class StatusPipe implements PipeTransform {
    protected entityService = inject(BazisEntityService);

    /**
     * Load status by id and return its `$snapshot`.
     *
     * @param id Status id string.
     * @returns Observable of `$snapshot` or `of(null)` when id is empty.
     */
    transform(id: string) {
        if (!id) return of(null);

        return this.entityService.getEntity$('statusy.status', id).pipe(map((v) => v?.$snapshot));
    }
}
